import { calcLineItemTotals } from "../proposalUtils";

export const lineCost = (item, t) => {
  const qty = t.qty || 1;
  const frt = t.totalFreightCostForItem || 0;
  if (item.pricing_mode === "subcontract") return (parseFloat(item.subcontract_cost) || 0) * qty + frt;
  if (item.pricing_mode === "flat_rate") return t.hours * t.labC * qty + frt;
  return t.matC * qty + t.hours * t.labC * qty + frt;
};

export const gmPct = (sell, cost) => (sell > 0 ? ((sell - cost) / sell) * 100 : null);

// Same roll-up the Cards view uses, plus cost + GM for the section row.
export const scopeRollup = (scope) => {
  const r = (scope.line_items || []).reduce((acc, li) => {
    const t = calcLineItemTotals(li);
    const isSub = li.pricing_mode === "subcontract";
    const qty = t.qty || 1;
    return {
      material: acc.material + t.totalMat * qty,
      freight: acc.freight + t.totalFreightForItem,
      labor: acc.labor + (isSub ? 0 : t.totalLab * qty),
      subcontract: acc.subcontract + (isSub ? t.totalLab * qty : 0),
      hours: acc.hours + t.hours * qty,
      total: acc.total + t.grand,
      cost: acc.cost + lineCost(li, t),
    };
  }, { material: 0, freight: 0, labor: 0, subcontract: 0, hours: 0, total: 0, cost: 0 });
  // Equipment / travel / disposal / drive time are job-level (Other Costs card) — not part of the scope roll-up.
  r.gm = gmPct(r.total, r.cost);
  r.lines = (scope.line_items || []).length;
  return r;
};

export const lineBadges = (item, t) => {
  const b = [];
  if ((item.pricing_mode || "standard") === "subcontract") b.push("SUB");
  if ((t.grand || 0) === 0) b.push("Incomplete");
  return b;
};

export const uomOf = (item) => (item.pricing_mode === "subcontract" ? "sub" : item.pricing_mode === "flat_rate" ? "flat" : "ea");

export const DEFAULT_COLS = { freight: true, stock: true, hrsTotal: true, rate: true };
export const colCount = (cols) => 12 + (cols.freight ? 1 : 0) + (cols.stock ? 1 : 0) + (cols.hrsTotal ? 1 : 0) + (cols.rate ? 1 : 0);
